import React from 'react';

export default function SimpleLoading (props) {
  const { isLoading = false, ...extraProps } = props;
  return isLoading ? (
    <span className="fas fa-spin fa-spinner" />
  ) : props.children;
}
